import {Button, Group, Stack, Text} from '@mantine/core';
import React, {useState} from 'react';

import {BearerTokenConsumer, getBearerToken} from 'auth/TokensDAO';
import notifications from 'notifications';
import BenchlingIcon from 'ui-library/icons/BenchlingIcon';
import copyToClipboard from 'util/clipboard/copyToClipboard';

export default function V3ExplorerBearerTokenSection(): JSX.Element {
  const [isFetching, setIsFetching] = useState(false);

  async function fetchAndCopyToken(): Promise<void> {
    const token = await getBearerToken({bearerTokenConsumer: BearerTokenConsumer.V3_EXPLORER});
    await copyToClipboard(token.access_token, {
      showToastOnSuccess: true,
      toastText: 'Copied token to clipboard.',
    });
  }

  function handleCopyToken(): void {
    setIsFetching(true);
    fetchAndCopyToken()
      .catch(notifications.notifyError)
      .finally(() => {
        setIsFetching(false);
      });
  }

  return (
    <Stack spacing="xs" mt="lg">
      <Text fw={600}>V3 API Explorer token</Text>
      <Text size="sm" c="dimmed">
        Copy a short-lived bearer token to authenticate the V3 API Explorer. Intended for use with the V3 API
        Explorer only. Expires in 15 minutes — copy a new one when it expires. Treat it like a password;
        don&apos;t share or embed it.
      </Text>
      <Group spacing={0}>
        <Button
          variant="tertiary"
          loading={isFetching}
          leftIcon={<BenchlingIcon icon="copy" />}
          onClick={handleCopyToken}
        >
          Copy V3 API Explorer token
        </Button>
      </Group>
    </Stack>
  );
}
